
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code5 } from "@/views/resources/documentation/element-ui/basic/layout/code";

export default defineComponent({
  name: "alignment",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code5
    };
  }
});
